import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchServicesMobile from "../search-services/SearchServicesMobile";
import { TypeAnimation } from "react-type-animation";
import { ResponseObject } from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";

export default function SearchBarMobileView() {
  const [open, setOpen] = React.useState(false);
  const [isSearchItemSelected, setIsSearchItemSelected] = React.useState(false);
  const [searchServices, setSearchServices] = React.useState("");
  const [optionList, setOptionList] = useState([]);
  const [serviceName, setServiceName] = useState("");
  const apiService = React.useMemo(() => new ApiService(), []);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
    setIsSearchItemSelected(false);
    setSearchServices("");
    setOptionList([]);
  };
  const handleSearch = (item: any, i: number) => {
    setServiceName(item);
    setSearchServices(item);
    setIsSearchItemSelected(true);
  };
  const handleClearSearch = () => {
    setSearchServices("");
    setOptionList([]);
  };
  const handleSearchInputServices = (e: any) => {
    setSearchServices(e.target.value.toLowerCase());
  };
  const handleSearchFieldClick = () => {
    setIsSearchItemSelected(false);
  };

  const getSearchServices = React.useCallback(async () => {
    try {
      if (searchServices) {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.searchServicesKeywords + searchServices
          );
        const response = responseObject?.object;
        setOptionList(response);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, searchServices]);

  React.useEffect(() => {
    getSearchServices();
  }, [searchServices, getSearchServices]);

  const DrawerList = (
    <Box sx={{ width: "100vw" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
          padding: "0.5rem 0.5rem 0.6rem",
          position: "fixed",
          background: "white",
          width: "100%",
          boxShadow: "1px 1px 5px 1px rgba(0, 0, 0, 0.2)",
          zIndex: 1000,
        }}
      >
        <KeyboardBackspaceIcon
          sx={{
            background: "#fff",
            borderRadius: "10rem",
            padding: "4px",
            fontSize: "30px",
            cursor: "pointer",
            color: "black",
            border: "1px solid gray",
          }}
          onClick={toggleDrawer(false)}
        />
        <TextField
          id="standard-basic"
          label="Search for services"
          variant="standard"
          color="success"
          sx={{ width: "100%", marginLeft: "1rem" }}
          value={searchServices}
          onChange={handleSearchInputServices}
          onClick={handleSearchFieldClick}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleClearSearch}>
                  <CloseIcon sx={{ color: "gray", marginRight: "0.5rem" }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        sx={{
          marginTop: "4rem",
          marginBottom: "6rem",
        }}
      >
        {isSearchItemSelected ? (
          <SearchServicesMobile serviceName={serviceName} />
        ) : (
          <List>
            {optionList && optionList?.length > 0 ? (
              optionList?.map((item, index) => (
                <Box key={index}>
                  <ListItem
                    disablePadding
                    onClick={() => handleSearch(item, index)}
                  >
                    <ListItemButton>
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{
                          fontWeight: "600",
                          textAlign: "center",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </Box>
              ))
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "80vh",
                }}
              >
                <Typography variant="body1">Search For Services...</Typography>
              </Box>
            )}
          </List>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Box
        sx={{
          border: "1px solid #c3c0c0",
          padding: "6px 8px",
          width: "-webkit-fill-available",
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
          borderRadius: "8px",
          background: "white",
          margin: "0px auto 8px",
        }}
        onClick={toggleDrawer(true)}
      >
        <SearchIcon
          sx={{
            color: "#005200",
          }}
        />{" "}
        &nbsp;
        <Typography variant="body1">Search for</Typography>
        &nbsp;
        <TypeAnimation
          sequence={[
            "Body Polishing",
            1000,
            "Facial",
            1000,
            "Waxing",
            1000,
            "Manicure",
            1000,
            "Pedicure",
            1000,
          ]}
          wrapper="span"
          speed={1}
          style={{ display: "inline-block", fontWeight: "600" }}
          repeat={Infinity}
        />
      </Box>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
